<template>
    <div class="vue-calendar-filter">
        <date-picker
            v-model="pickedDate"
            type="date"
            range
            :placeholder="placeHolder"
            :disabled-date="disabledDates"
            :shortcuts="shortcuts"
        ></date-picker>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/nl';

export default {
    name: "CalendarFilter",

    props: ['placeHolder'],

    components: { DatePicker },

    data() {
        return {
            pickedDate: [],
            urlParams: [],
            translations: {
                selectDateExplanation: window.Drupal.t('Select a from and to date.'),
            },
            shortcuts: [
                {
                    text: window.Drupal.t('Today'),
                    onClick() {
                        return [new Date(), new Date()];
                    },
                },
                {
                    text: window.Drupal.t('Next weekend'),
                    onClick() {
                        const date = new Date();

                        date.setHours(0);
                        date.setMinutes(0);
                        date.setSeconds(0);
                        date.setMilliseconds(0);

                        return [
                            new Date(date.setDate(date.getDate() - (date.getDay() - 1) + 4)),
                            new Date(date.setDate(date.getDate() - (date.getDay() - 1) + 6))
                        ];
                    },
                },
            ],
        }
    },

    mounted() {
        const urlParams = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });

        if(!_.isEmpty(urlParams.startDate) && !_.isEmpty(urlParams.endDate)) {
            this.pickedDate = [new Date(urlParams.startDate * 1000), new Date(urlParams.endDate * 1000)];
        }
    },

    methods: {
        disabledDates(date) {
            return date < (new Date()).setHours(0, 0, 0, 0);
        }
    },

    watch: {
        pickedDate: _.debounce(function(date) {
            if(_.isNil(date[0]) || _.isNil(date[1])) {
                this.$emit('filter-changed', {
                    slug: 'calendar',
                    items: null
                })
                return;
            }

            const startDate = Math.floor(date[0].getTime() / 1000);
            const endDate = Math.floor(date[1].getTime() / 1000);

            this.$emit('filter-changed', {
                slug: 'calendar',
                items: {
                    startDate: startDate,
                    endDate: (endDate + (24 * 3600)),
                }
            });
        }, 200)
    }
}
</script>
